import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  IconButton,
  Stack,
  Tabs,
  Tab,
  CircularProgress,
  Popover,
} from "@mui/material";
import totalreviews from "../../images/totalreviews.png";
import totalratings from "../../images/totalratings.png";
import totalscans from "../../images/totalscans.png";
import activeoffers from "../../images/activeoffers.png";
import sliderlefticon from "../../images/sliderlefticon.png";
import sliderrighticon from "../../images/sliderrighticon.png";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import axiosInstance from "../axios";
import { BusinessContext } from "../BusinessContext";
import { Rating } from "@mui/material";
import { Avatar } from "@mui/material";
import { styled } from "@mui/system";
import Slider from "react-slick";
import imageoffer from "../../images/imageoffer.png";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { DateRange } from "react-date-range";
import { format } from "date-fns";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { enUS } from "date-fns/locale";
import { useTranslation } from 'react-i18next';

const DashboardContent = () => {
  const [activeButton, setActiveButton] = useState("");
  const [value, setValue] = useState(0);
  const { selectedBusinessId } = useContext(BusinessContext);
  const [businessData, setBusinessData] = useState([]);
  const [businessDataspecials, setBusinessDataspecials] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [cardsPerSlide, setCardsPerSlide] = useState();
  const [chartData, setChartData] = useState([]);
  const [selectedScansDateRange, setSelectedScansDateRange] = useState(null);
  const today = new Date();
  const priorDate = new Date();
  priorDate.setDate(today.getDate() - 29);
  const [scansdateRange, setsScansDateRange] = useState([
    {
      startDate: priorDate,
      endDate: today,
      key: "selection",
    },
  ]);
  const [clicksData, setClicksData] = useState([]);
  const [anchorElClicks, setAnchorElClicks] = useState(null); // for Clicks
  const [anchorElScans, setAnchorElScans] = useState(null); // for Scans
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [isDateRangeLoading, setIsDateRangeLoading] = useState(false);
  const [dateRange, setDateRange] = useState([
    {
      startDate: priorDate,
      endDate: today,
      key: "selection",
    },
  ]);
  const [isScansDateInvalid, setIsScansDateInvalid] = useState(false);
  const [isClicksDateInvalid, setIsClicksDateInvalid] = useState(false);
  const sliderRef = useRef(null);
  const toastRef = useRef(null);
  const { t } = useTranslation();
  const providerColorMap = {
    google: "#4285F4",
    instagram: "#E1306C",
    whatsapp: "#25D366",
    yelp: "#AF0606",
    facebook: "#1461C0",
    tiktok: "#010101",
    tripadvisor: "#34E0A1",
    customprovider_8: "#FF9800",
    customprovider_9: "#9C27B0",
  };

  const getRandomColor = (provider) => {
    const key = provider.toLowerCase();
    return providerColorMap[key] || "#CCCCCC";
  };

  const Customslider = styled(Slider)({
    slider: {
      "& .slick-slide": {
        // display: 'inline-block',
        marginRight: "16px",
      },
    },
  });

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1200) {
        setCardsPerSlide(1);
      } else if (window.innerWidth < 1440) {
        setCardsPerSlide(2);
      } else {
        setCardsPerSlide(3);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const fetchBusinessesspecials = async () => {
      setIsLoading(true);
      try {
        const response = await axiosInstance.post(
          "places.php?method=get_business_specials",
          {
            business_id: selectedBusinessId,
          }
        );
        if (response.data.place_details);
        setBusinessDataspecials(response.data);
      } catch (err) {
        console.log("error", err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchBusinessesspecials();
  }, [selectedBusinessId]);

  useEffect(() => {
    const fetchBusinesses = async () => {
      setIsLoading(true);
      try {
        const response = await axiosInstance.post(
          "places.php?method=get_place_details",
          {
            id: selectedBusinessId,
          }
        );
        if (response?.data?.place_details);
        setBusinessData(response.data.place_details);
      } catch (err) {
        console.log("error", err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchBusinesses();
  }, [selectedBusinessId]);


  useEffect(() => {
    fetchChartData(priorDate, today);
    fetchClickReports(priorDate, today);
  }, [selectedBusinessId]);

  const fetchClickReports = async (start = null, end = null) => {
    setIsDateRangeLoading(true);
    try {
      const payload = {
        business_id: selectedBusinessId,
        ...(start &&
          end && {
            start_date: format(start, "yyyy-MM-dd"),
            end_date: format(end, "yyyy-MM-dd"),
          }),
      };

      const response = await axiosInstance.post(
        "orders.php?method=generate_clicks_reports",
        payload
      );

      if (response.data.clicks) {
        const chartData = response.data.clicks.map((item, index) => ({
          id: index,
          value: parseInt(item.click_count),
          name: item.provider.includes("customprovider")
            ? item.provider_label
            : item.provider_label || item.provider,
          color: getRandomColor(item.provider),
        }));
        setClicksData(chartData);
      }
    } catch (err) {
      console.log("error", err);
    }
    setIsDateRangeLoading(false);
  };

  const handleOpenCalendar = (event) => {
    setAnchorElClicks(event.currentTarget);
  };

  const handleApplyDate = () => {
    const { startDate, endDate } = dateRange[0];
    if (!endDate || startDate.getTime() === endDate.getTime()) {
      setIsClicksDateInvalid(true);
      return;
    }
    setIsClicksDateInvalid(false);
    setSelectedDateRange(dateRange[0]);
    fetchClickReports(startDate, endDate);
    setAnchorElClicks(null);
  };

  const handleReset = () => {
    setSelectedDateRange(null);
    fetchClickReports();
    setAnchorElClicks(null);
  };

  const formatChartData = (apiData) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    return apiData.map((item) => {
      const date = new Date(item.created_at);
      const day = date.getDate();
      const month = monthNames[date.getMonth()];

      return {
        name: `${month}, ${day}`,
        Scans: Number(item.click),
      };
    });
  };

  const fetchChartData = async (start = null, end = null) => {
    setIsDateRangeLoading(true);
    try {
      const payload = {
        business_id: selectedBusinessId,
        ...(start &&
          end && {
            start_date: format(start, "yyyy-MM-dd"),
            end_date: format(end, "yyyy-MM-dd"),
          }),
      };

      const response = await axiosInstance.post(
        "orders.php?method=generate_scans_reports",
        payload
      );
      const transformedData = formatChartData(response.data.clicks);
      setChartData(transformedData);
    } catch (error) {
      console.error("Error fetching chart data", error);
    }
    setIsDateRangeLoading(false);
  };

 
  const handleScansOpenCalender = (event) => {
    setAnchorElScans(event.currentTarget);
  };

  const handleApplyScansDate = () => {
    const { startDate, endDate } = scansdateRange[0];
  if (!endDate || startDate.getTime() === endDate.getTime()) {
    setIsScansDateInvalid(true);
    return;
  }
  setIsScansDateInvalid(false);
  setSelectedScansDateRange(scansdateRange[0]);
  fetchChartData(startDate, endDate);
    setAnchorElScans(null);
  };

  const handleScansReset = () => {
    setSelectedScansDateRange(null);
    fetchChartData();
    setAnchorElScans(null);
  };

  const CustomTool = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const total = clicksData.reduce((sum, item) => sum + item.value, 0);
      const percent = ((payload[0].value / total) * 100).toFixed(1);
      return (
        <Box
          sx={{
            backgroundColor: "var(--pg-card)",
            color: "var(--pg-text)",
            py: "4px",
            px: "10px",
            border: "1px solid var(--pg-border)",
            display: "flex",
          }}
        >
          <Typography
            sx={{
              pr: "8px",
              fontSize: "14px",
              fontfamily: "Roboto",
              fontWeight: "500",
            }}
          >
            {payload[0].name}
          </Typography>
          <Typography
            sx={{ fontSize: "14px", fontfamily: "Roboto", fontWeight: "500" }}
          >
            {payload[0].value} {t("Clicks")}
            {/* ({percent}%) */}
          </Typography>
        </Box>
      );
    }
    return null;
  };
  const settings = {
    infinite: false, // Disable infinite scroll
    slidesToShow: 3, // Always show 3 slides
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 2.7,
          centerPadding: "30px",
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 2.4,
          centerPadding: "30px",
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2,
          centerPadding: "30px",
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          centerPadding: "10px",
        },
      },
      {
        breakpoint: 1130,
        settings: {
          slidesToShow: 1.6,
          centerPadding: "10px",
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 780,
        settings: {
          slidesToShow: 1.8,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const handlePrevClick = () => {
    if (sliderRef.current) {
      const currentSlide = sliderRef.current.innerSlider.state.currentSlide;
      if (currentSlide > 0) {
        sliderRef.current.slickPrev();
      }
    }
  };

  const handleNextClick = () => {
    if (sliderRef.current) {
      const innerSlider = sliderRef.current.innerSlider;
      const currentSlide = innerSlider.state.currentSlide;
      const slideCount = innerSlider.props.children.length;
      const slidesToShow = innerSlider.props.slidesToShow || 1;

      const maxSlide = slideCount - slidesToShow;

      if (currentSlide < maxSlide) {
        sliderRef.current.slickNext();
      }
    }
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <Box
          sx={{
            background: "var(--pg-card)",
            color: "var(--pg-text)",
            padding: "5px 10px",
            borderRadius: "5px",
            boxShadow: 2,
          }}
        >
          <Typography fontSize={12} color="var(--pg-text)">
            🔵  {t("Scans")}: <strong>{payload[0].value}</strong>
          </Typography>
        </Box>
      );
    }
    return null;
  };

  const totalScans = businessData?.plates?.reduce(
    (sum, plate) => sum + plate.scans,
    0
  );
  const visibleReviews = showAll
    ? businessData?.reviews
    : businessData?.reviews?.slice(0, 3);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const handleCopy = (text) => {
    if (text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          if (toastRef.current) {
            toastRef.current.style.display = "flex";
            setTimeout(() => {
              if (toastRef.current) {
                toastRef.current.style.display = "none";
              }
            }, 2000);
          }
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    }
  };

  if (isloading) {
    return (
      <>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh", // Full viewport height
          }}
        >
          <CircularProgress />
        </Box>
      </>
    );
  }

  if (!selectedBusinessId) {
    return (
      <>
        <Typography
          sx={{
            textAlign: "center",
            pt: "50px",
            fontFamily: "Nunito",
            fontSize: "20px",
            fontWeight: "600",
          }}
        >
          No businesses available at the moment.
        </Typography>
      </>
    );
  }

  return (
    <Box
      sx={{
        p: { xs: "10px 9px 10px 8px", sm: "10px  0px 10px 10px" },
        backgroundColor: "transparent",
        color: "var(--pg-text)",
      }}
    >
      <Grid container gap={{ xs: "12px", sm: "12px", md: "6px", lg: "12px" }}>
        <Grid item xs={12} sm={12} md={7} lg={6.8}>
          {/* business name */}

          <Box
            sx={{
              borderRadius: "8px",
              p: "15px",
              display: "flex",
              gap: "16px",
              alignItems: "center",
              backgroundColor: "var(--pg-card)",
              color: "var(--pg-text)",
              border: "1px solid var(--pg-border)",
            }}
          >
            {/* <Box
              component="img"
              src={dashboardname}
              sx={{ objectFit: "contain" }}
            /> */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",

                // justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontFamily: "Roboto",
                  fontWeight: "bold",
                  lineHeight: "100%",
                  color: "var(--pg-text)",
                }}
              >
                {businessData?.name}
              </Typography>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontFamily: "Roboto",
                  fontWeight: "500",
                  lineHeight: "20px",
                  color: "var(--pg-text-muted)",
                  wordBreak: "break-all",
                }}
              >
                {businessData?.address}
              </Typography>
            </Box>
          </Box>

          {/* likesand reviews count */}

          <Grid
            container
            pt={"10px"}
            gap={{ xs: "9px", lg: "10px", xl: "9px" }}
            sx={{
              "@media (min-width:1540px)": {
                gap: "8px",
              },
            }}
          >
            <Grid
              item
              xs={3.8}
              sm={3.6}
              md={3.6}
              lg={3.7}
              xl={3.9}
              sx={{
                borderRadius: "8px",
                p: "10px",
                backgroundColor: "var(--pg-card)",
                color: "var(--pg-text)",
                border: "1px solid var(--pg-border)",
                display: "flex",
                gap: { xs: "16px", sm: "12px" },
                justifyContent: "center",
              }}
            >
              <Box
                component="img"
                src={totalreviews}
                width={"31px"}
                height={"31px"}
              />
              <Box>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontFamily: "Roboto",
                    fontWeight: "400px",
                    lineHeight: { xs: "15px", sm: "100%" },
                    color: "var(--pg-text)",
                  }}
                >
                   {t("Reviews")}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontFamily: "Roboto",
                    fontWeight: "700",
                    lineHeight: "100%",
                    color: "var(--pg-text)",
                    pt: "2px",
                  }}
                >
                  {businessData?.review_count}
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={3.8}
              sm={3.9}
              xl={3.9}
              sx={{
                borderRadius: "8px",
                p: "10px",
                backgroundColor: "var(--pg-card)",
                color: "var(--pg-text)",
                border: "1px solid var(--pg-border)",
                display: "flex",
                gap: "12px",
                justifyContent: "center",
              }}
            >
              <Box
                component="img"
                src={totalratings}
                width={"31px"}
                height={"31px"}
              />
              <Box>
                <Typography
                  sx={{
                    fontSize: "13px",
                    fontFamily: "Roboto",
                    fontWeight: "400px",
                    lineHeight: { xs: "15px", sm: "100%" },
                    color: "var(--pg-text)",
                  }}
                >
                  {t("Ratings")}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontFamily: "Roboto",
                    fontWeight: "700",
                    lineHeight: "100%",
                    color: "var(--pg-text)",
                    pt: "2px",
                  }}
                >
                  {businessData?.rating}
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={3.72}
              sm={3.9}
              xl={3.9}
              sx={{
                borderRadius: "8px",
                p: "10px",
                backgroundColor: "var(--pg-card)",
                color: "var(--pg-text)",
                border: "1px solid var(--pg-border)",
                display: "flex",
                gap: "12px",
                justifyContent: "center",
              }}
            >
              <Box
                component="img"
                src={totalscans}
                width={"31px"}
                height={"31px"}
              />
              <Box>
                <Typography
                  sx={{
                    fontSize: "13px",
                    fontFamily: "Roboto",
                    fontWeight: "400px",
                    lineHeight: { xs: "15px", sm: "100%" },
                    color: "var(--pg-text)",
                  }}
                >
                  {t("Scans")}
                </Typography>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontFamily: "Roboto",
                    fontWeight: "700",
                    lineHeight: "100%",
                    color: "var(--pg-text)",
                    pt: "2px",
                  }}
                >
                  {totalScans}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          {/* active orders expired offers */}

          <Box
            sx={{
              borderRadius: "8px",
              px: "18px",
              pb: "15px",
              pt: "10px",
              backgroundColor: "var(--pg-card)",
              color: "var(--pg-text)",
              border: "1px solid var(--pg-border)",
              mt: "10px",
            }}
          >
            <Box
              sx={{
                display: { xs: "flex", sm: "flex" },
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #BFBFBF",
                // pb: "8px",
                heminHeight: "32px",
              }}
            >
              <Box sx={{ order: { xs: "2", sm: "1" } }}>
                <Tabs
                  value={value}
                  onChange={handleTabChange}
                  TabIndicatorProps={{ style: { display: "none" } }}
                  sx={
                    {
                      // minHeight: "32px", // Reduce Tabs height
                    }
                  }
                >
                  <Tab
                    label={
                      <Box display="flex" alignItems="center">
                        <Box component="img" src={activeoffers} pr={"3px"} />
                        {t("Active Offers")}
                      </Box>
                    }
                    sx={{
                      fontSize: "14px",
                      fontFamily: "Inter",
                      fontWeight: "500",
                      lineHeight: "21px",
                      textTransform: "capitalize",
                      color: value === 0 ? "#0041A8" : "var(--pg-text)",
                      borderBottom: value === 0 ? "3px solid #0041A8" : "none",
                      p: 0,
                      minWidth: "auto",
                      marginRight: "25px",
                    }}
                  />
                </Tabs>
              </Box>
            </Box>
            <Box
              width="100%"
              textAlign="center"
              pt={"10px"}
              pb={"8px"}
              sx={{
                "& .slick-slide": {
                  maxwidth: "225px !important",
                },
              }}
            >
              {businessDataspecials?.specials?.filter(
                (item) => item.status === "1"
              )?.length > 0 ? (
                <Customslider ref={sliderRef} {...settings}>
                  {businessDataspecials?.specials
                    ?.filter((item) => item.status === "1")
                    .map((item) => (
                      <Box
                        key={item.id}
                        sx={{
                          maxWidth: "224px",
                          height: "250px",
                          borderRadius: "8px",
                          border: "1px solid #DFDFDF",
                          transition: "transform 0.3s ease-in-out",
                        }}
                      >
                        <img
                          src={item.image || imageoffer}
                          alt="Coupon"
                          style={{
                            width: "222px",
                            height: "150px",
                            objectFit: "cover",
                          }}
                        />
                        <Box sx={{ p: "10px" }}>
                          <Typography
                            variant="subtitle1"
                            sx={{
                              fontSize: "13px",
                              fontFamily: "Roboto",
                              fontWeight: "700",
                              lineHeight: "100%",
                              color: "var(--pg-text)",
                              textAlign: "start",
                              pt: "10px",
                            }}
                          >
                            {item.menu_name}
                          </Typography>
                          <Box>
                            <Stack
                              direction="row"
                              mt={2}
                              alignItems="center"
                              gap={"5px"}
                            >
                              <Button
                                variant="contained"
                                sx={{
                                  backgroundColor: "#0343AA",
                                  fontSize: "13px",
                                  fontFamily: "Roboto",
                                  fontWeight: "600",
                                  lineHeight: "100%",
                                  textTransform: "capitalize",
                                  borderRadius: "25px",
                                  px: "10px",
                                }}
                              >
                                {item.coupon_code}
                              </Button>
                              <ContentCopyIcon
                                sx={{
                                  fontSize: "15px",
                                  mx: "3px",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleCopy(item?.coupon_code)}
                              />
                            </Stack>
                          </Box>
                        </Box>
                      </Box>
                    ))}
                </Customslider>
              ) : (
                <>
                  <Typography sx={{ fontSize: "14px", fontFamily: "Roboto" }}>
                  {t("No Offers available")}
                  </Typography>
                </>
              )}

              {/* Navigation Buttons Below */}
              {businessDataspecials?.specials?.filter(
                (item) => item.status === "1"
              )?.length > 3 && (
                <Stack
                  direction="row"
                  justifyContent="end"
                  alignItems="center"
                  mt={2}
                  gap={2}
                >
                  <IconButton
                    onClick={handlePrevClick}
                    sx={{
                      border: "1px solid #DEE3F2",
                      borderRadius: "25px",
                      width: "40px",
                      height: "40px",
                      backgroundColor:
                        activeButton === "left" ? "#DEE3F2" : "transparent",
                    }}
                  >
                    <img src={sliderlefticon} alt="icon" />
                  </IconButton>

                  <IconButton
                    onClick={handleNextClick}
                    sx={{
                      border: "1px solid #DEE3F2",
                      borderRadius: "25px",
                      width: "40px",
                      height: "40px",
                      backgroundColor:
                        activeButton === "right" ? "#DEE3F2" : "transparent",
                    }}
                  >
                    <img src={sliderrighticon} alt="icon" />
                  </IconButton>
                </Stack>
              )}

              <Box
                ref={toastRef}
                sx={{
                  position: "fixed",
                  // bottom: "20px",
                  top: { xs: "initial", sm: "68%" },
                  left: { xs: "50%", sm: "40%" },
                  transform: "translateX(-50%)",
                  backgroundColor: "green",
                  color: "#fff",
                  borderRadius: "8px",
                  px: 2,
                  py: "5px",
                  zIndex: 1300,
                  display: "none",
                  alignItems: "center",
                  gap: 1,
                  fontFamily: "Roboto",
                  fontWeight: 500,
                }}
              >
                <CheckCircleIcon sx={{ fontSize: 16, color: "white" }} />
                <Typography sx={{ fontSize: { xs: "12px", sm: "14px" } }}>
                {t("Coupon code copied")}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* graph overview*/}

          <Box
            sx={{
              border: "1px solid var(--pg-border)",
              borderRadius: "8px",
              p: 2,
              background: "var(--pg-card)",
              color: "var(--pg-text)",
              mt: "10px",
            }}
          >
            {/* Header */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2.5}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                  fontFamily: "Roboto",
                  lineHeight: "100%",
                  color: "var(--pg-text)",
                }}
              >
                {t("Scans Overview")}
              </Typography>

             
                <Stack direction="row" spacing={1} alignItems="center">
                  <Button
                    onClick={handleScansOpenCalender}
                    endIcon={<CalendarMonthIcon />}
                    variant="outlined"
                    size="small"
                  >
                    {selectedScansDateRange
                      ? `${format(
                          selectedScansDateRange.startDate,
                          "MMM dd"
                        )} - ${format(
                          selectedScansDateRange.endDate,
                          "MMM dd"
                        )}`
                      : t("Filter by")}
                  </Button>

                  <Button
                    onClick={handleScansReset}
                    variant="text"
                    size="small"
                  >
                    {t("Reset")}
                  </Button>
                </Stack>
             
            </Box>
            <Popover
              open={Boolean(anchorElScans)}
              anchorEl={anchorElScans}
              onClose={() => setAnchorElScans(null)}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
              <Box p={2}>
                <DateRange
                  editableDateInputs={true}
                  onChange={(item) => setsScansDateRange([item.selection])}
                  moveRangeOnFirstSelection={false}
                  ranges={scansdateRange}
                  maxDate={new Date()}
                  locale={enUS}
                  className={isScansDateInvalid ? "invalid-date-range" : ""}
                />
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  spacing={1}
                  mt={1}
                >
                  <Button
                    size="small"
                    onClick={handleApplyScansDate}
                    variant="contained"
                  >
                     {t("Apply")}
                  </Button>
                </Stack>
              </Box>
            </Popover>
            <ResponsiveContainer width="100%" height={250}>
              {chartData && chartData.length > 0 ? (
                <BarChart data={chartData} barSize={24}>
                  <CartesianGrid stroke="#E5E5E5" vertical={false} />{" "}
                  <XAxis
                    dataKey="name"
                    tickLine={false}
                    axisLine={{ stroke: "#E5E5E5" }}
                    tick={{
                      fontSize: "12px",
                      fontWeight: 400,
                      fontFamily: "Roboto",
                      fill: "#8F9BB3",
                      lineHeight: "16px",
                    }}
                  />
                  <YAxis
                    tickFormatter={(value) => `${value}`}
                    tickLine={false}
                    axisLine={false}
                    domain={[0, "dataMax"]}
                    allowDecimals={false}
                    width={30}
                    tick={{
                      fontSize: "12px",
                      fontWeight: 400,
                      fontFamily: "Roboto",
                      fill: "#8F9BB3",
                      lineHeight: "16px",
                    }}
                  />
                  <Tooltip content={<CustomTooltip />} />
                  <Legend
                    verticalAlign="bottom"
                    iconType="circle"
                    wrapperStyle={{
                      fontSize: "11px",
                      fontWeight: 400,
                      fontFamily: "Roboto",
                      color: "var(--pg-text)",
                      lineHeight: "100%",
                    }}
                  />
                  <Bar dataKey="Scans" fill="#54AEF8" radius={[4, 4, 0, 0]} />
                </BarChart>
              ) : (
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontFamily: "Roboto",
                    textAlign: "center",
                    pt: "20px",
                  }}
                >
                   {t("No Scans Available")}
                </Typography>
              )}
            </ResponsiveContainer>
          </Box>

          {/* chart  */}
          <Box
            height={300}
            sx={{
              backgroundColor: "var(--pg-card)",
              color: "var(--pg-text)",
              border: "1px solid var(--pg-border)",
              mt: "10px",
              mb: "4px",
              borderRadius: "6px",
              position: "relative",
              px: 2,
              pt: 1,
            }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontWeight: "600",
                  fontFamily: "Roboto",
                }}
              >
                {t("Clicks Overview")}
              </Typography>

            
                <Stack direction="row" spacing={1} alignItems="center">
                  <Button
                    onClick={handleOpenCalendar}
                    endIcon={<CalendarMonthIcon />}
                    variant="outlined"
                    size="small"
                  >
                    {selectedDateRange
                      ? `${format(
                          selectedDateRange.startDate,
                          "MMM dd"
                        )} - ${format(selectedDateRange.endDate, "MMM dd")}`
                      :  t("Filter by")}
                  </Button>

                  <Button onClick={handleReset} variant="text" size="small">
                  {t("Reset")}
                  </Button>
                </Stack>
             
            </Box>

            <Popover
              open={Boolean(anchorElClicks)}
              anchorEl={anchorElClicks}
              onClose={() => setAnchorElClicks(null)}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
              <Box p={2}>
                <DateRange
                  editableDateInputs={true}
                  onChange={(item) => setDateRange([item.selection])}
                  moveRangeOnFirstSelection={false}
                  ranges={dateRange}
                  maxDate={new Date()}
                  locale={enUS}
                  className={isClicksDateInvalid ? "invalid-date-range" : ""}
                />
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  spacing={1}
                  mt={1}
                >
                  <Button
                    size="small"
                    onClick={handleApplyDate}
                    variant="contained"
                  >
                    {t("Apply")}
                  </Button>
                </Stack>
              </Box>
            </Popover>

            {/* Chart Section */}
            {clicksData && clicksData.length > 0 ? (
              <ResponsiveContainer>
                <PieChart>
                  <Pie
                    data={clicksData}
                    dataKey="value"
                    nameKey="name"
                    cx="50%"
                    cy="42%"
                    outerRadius={100}
                    innerRadius={36}
                  >
                    {clicksData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Pie>
                  <Tooltip content={<CustomTool />} />
                  <Legend
                    verticalAlign="middle"
                    align="right"
                    layout="vertical"
                  />
                </PieChart>
              </ResponsiveContainer>
            ) : (
              <Typography
                sx={{
                  fontSize: "14px",
                  fontFamily: "Roboto",
                  textAlign: "center",
                  pt: "20px",
                }}
              >
                 {t("No Clicks Available")}
              </Typography>
            )}
          </Box>
          {isDateRangeLoading && (
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(255,255,255,0.6)",
                backdropFilter: "blur(1px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 10,
              }}
            >
              <CircularProgress size={40} />
            </Box>
          )}
        </Grid>

        {/* second grid */}

        <Grid item xs={12} sm={12} md={4.8} lg={5}>
          <Box
            sx={{
              borderRadius: "8px",
              p: " 15px",

              backgroundColor: "var(--pg-card)",
              color: "var(--pg-text)",
              border: "1px solid var(--pg-border)",
            }}
          >
            <>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                  fontFamily: "Roboto",
                  lineHeight: "100%",
                  color: "var(--pg-text)",
                }}
              >
                {t("Latest Reviews")}
              </Typography>
              {visibleReviews?.map((review, index) => (
                <Box
                  key={index}
                  sx={{
                    border: "1px solid var(--pg-border)",
                    p: "6px 10px 15px 15px",
                    mt: "14px",
                    borderRadius: "8px",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: "12px",
                      fontWeight: "400",
                      lineHeight: "16px",
                      color: "var(--pg-text-muted)",
                      textAlign: "end",
                    }}
                  >
                    {formatDate(review.created_at)}
                  </Typography>
                  <Box
                    sx={{ display: "flex", gap: "10px", alignItems: "center" }}
                  >
                    <Avatar
                      sx={{
                        width: 40,
                        height: 40,
                        fontSize: "16px",
                        fontWeight: "bold",
                      }}
                    >
                      {review.name
                        .split(" ") // Split name into words
                        .map((word) => word.charAt(0)) // Get first letter of each word
                        .join("")}{" "}
                      {/* Join initials */}
                    </Avatar>

                    <Box>
                      <Typography
                        sx={{
                          fontFamily: "Roboto",
                          fontSize: "14px",
                          fontWeight: "400",
                          lineHeight: "11px",
                          color: "var(--pg-text)",
                          pb: "3px",
                        }}
                      >
                        {review.name}
                      </Typography>
                      <Rating
                        value={review.rating}
                        readOnly
                        precision={1}
                        sx={{ fontSize: "18px" }}
                      />
                    </Box>
                  </Box>
                  <Typography
                    sx={{
                      fontFamily: "Roboto",
                      fontSize: "14px",
                      fontWeight: "400",
                      lineHeight: "20px",
                      color: "var(--pg-text-secondary)",
                      pt: "10px",
                    }}
                  >
                    {review.comment}
                  </Typography>
                </Box>
              ))}
            </>
            {businessData?.reviews?.length > 3 && (
              <Box sx={{ textAlign: "center", pt: "20px", pb: "10px" }}>
                <Button
                  onClick={() => setShowAll(!showAll)}
                  sx={{
                    textTransform: "capitalize",
                    color: "#0343AA",
                    border: "1px solid var(--pg-border)",
                    fontSize: "16px",
                    fontWeight: "400",
                    fontFamily: "Roboto",
                    lineHeight: "100%",
                    py: "10px",
                    px: "18px",
                    borderRadius: "8px",
                  }}
                >
                  {showAll ? t("Show Less") : t("View All Reviews")}
                </Button>
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DashboardContent;
